import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaSave, FaUndo, FaEdit } from 'react-icons/fa';
import { LuPanelLeft, LuMenu } from 'react-icons/lu';
import { useToast } from '../../../context/ToastContext';
import PageLayout from '../../../components/ui/PageLayout';
import PageHeader from '../../../components/ui/PageHeader';

const SUB_PAGES = [
  {
    route: '/portal-cms/sidebar-header/sidebar',
    label: 'Sidebar',
    description: 'Sidebar logo, main navigation, services section, and Refer & Earn labels and icons',
    icon: LuPanelLeft,
    gradient: 'from-violet-500 to-purple-600',
  },
  {
    route: '/portal-cms/sidebar-header/header',
    label: 'Header',
    description: 'Welcome text, notifications, chat button, and profile menu labels',
    icon: LuMenu,
    gradient: 'from-rose-500 to-orange-600',
  },
];

const SidebarHeaderPortalCMS = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <PageHeader
        title="Sidebar & Header"
        description="Edit the User Portal sidebar logo, navigation, and top header text, labels, and icons."
        icon={LuPanelLeft}
        actions={
          <button type="button" onClick={() => navigate('/portal-cms')} className="px-4 py-2 rounded-xl border border-gray-200 dark:border-dark-600 text-sm">
            Back
          </button>
        }
      />

      <div className="mb-4">
        <h2 className="text-lg font-bold text-gray-900 dark:text-white mb-1">Layout pages</h2>
        <p className="text-sm text-gray-500 dark:text-gray-400">Choose Sidebar or Header to edit labels, icons, and button text.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {SUB_PAGES.map((page) => {
          const Icon = page.icon;
          return (
            <div key={page.route} className="bg-white dark:bg-dark-800 rounded-2xl border border-gray-100 dark:border-dark-700 shadow-card overflow-hidden flex flex-col">
              <div className={`h-2 bg-gradient-to-r ${page.gradient}`} />
              <div className="p-5 flex-1 flex flex-col">
                <div className={`w-11 h-11 rounded-xl bg-gradient-to-br ${page.gradient} flex items-center justify-center text-white shadow-lg mb-4`}>
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-bold text-gray-900 dark:text-white mb-1">{page.label}</h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-4 flex-1">{page.description}</p>
                <button type="button" onClick={() => navigate(page.route)} className="btn-premium text-sm py-2 px-4 flex items-center justify-center gap-2 w-full">
                  <FaEdit className="w-3.5 h-3.5" /> Edit {page.label}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </PageLayout>
  );
};

export default SidebarHeaderPortalCMS;
